module.exports = __webpack_public_path__ + "static/assets/88bf432021d6249c8418a307819e4875.png";